import React from 'react'
import PropTypes from 'prop-types'
import SectionHeader from './section-header'
import PersonForm from '../forms/person-form'
import ConfirmationForm from '../forms/confirmation-form'

function PersonInfoSection(props) {
  const { step, isLoading, alert, person } = props

  return <div className='person'>
    <SectionHeader title='YOUR INFO' />
    { step == 'person' && !person.id &&
      <PersonForm 
        alert={alert}
        person={person}
        verify={props.verify}
        verifyPerson={props.verifyPerson}
        isLoading={isLoading}
        setAlert={props.setAlert}
        onPrevStep={props.onPrevStep}
      />
    }
    { step == 'person' && person.id && 
      <ConfirmationForm 
        alert={alert}
        confirm={props.confirm}
        person={person}
        isLoading={isLoading}
        confirmCode={props.confirmCode}
        resendCode={props.resendCode}
        setAlert={props.setAlert}
        onPrevStep={props.onPrevStep}
      />
    }
  </div>
}

PersonInfoSection.propTypes = {
  step: PropTypes.string.isRequired,
  alert: PropTypes.object,
  person: PropTypes.object,
  verify: PropTypes.func.isRequired,
  confirm: PropTypes.func.isRequired,
  verifyPerson: PropTypes.func.isRequired,
  confirmCode: PropTypes.func.isRequired,
  resendCode: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  setAlert: PropTypes.func.isRequired,
  onNextStep: PropTypes.func.isRequired,
  onPrevStep: PropTypes.func.isRequired,
}

export default PersonInfoSection
